var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _circle107, _circle108, _circle109, _circle110, _circle111, _circle112, _circle113, _circle114, _circle115, _circle116, _circle117, _circle118, _circle119, _circle120, _circle121, _circle122, _circle123, _circle124, _circle125, _circle126, _circle127, _circle128, _circle129, _circle130, _circle131, _circle132, _circle133, _circle134, _circle135, _circle136, _circle137, _circle138, _circle139, _circle140, _circle141, _circle142, _circle143, _circle144, _circle145, _circle146, _circle147, _circle148, _circle149, _circle150, _circle151, _circle152, _circle153, _circle154, _circle155, _circle156, _circle157, _circle158, _circle159, _circle160, _circle161, _circle162, _circle163, _circle164, _circle165, _circle166, _circle167, _circle168, _circle169, _circle170, _circle171, _circle172, _circle173, _circle174, _circle175, _circle176, _circle177, _circle178, _circle179, _circle180, _circle181, _circle182, _circle183, _circle184, _circle185, _circle186, _circle187, _circle188, _circle189, _circle190, _circle191, _circle192, _circle193, _circle194, _circle195, _circle196, _circle197, _circle198, _circle199, _circle200, _circle201, _circle202, _circle203, _circle204, _circle205, _circle206, _circle207, _circle208, _circle209, _circle210, _circle211, _circle212, _circle213, _circle214, _circle215, _circle216, _circle217, _circle218, _circle219, _circle220, _circle221, _circle222, _circle223, _circle224, _circle225, _circle226, _circle227, _circle228, _circle229, _circle230, _circle231, _circle232, _circle233, _circle234, _circle235, _circle236, _circle237, _circle238, _circle239, _circle240, _circle241, _circle242, _circle243, _circle244, _circle245, _circle246, _circle247, _circle248, _circle249, _circle250, _circle251, _circle252, _circle253, _circle254, _circle255, _circle256, _circle257, _circle258, _circle259, _circle260, _circle261, _circle262, _circle263, _circle264, _circle265, _circle266, _circle267, _circle268, _circle269, _circle270, _circle271, _circle272, _circle273, _circle274, _circle275, _circle276, _circle277, _circle278, _circle279, _circle280, _circle281, _circle282, _circle283, _circle284, _circle285, _circle286, _circle287, _circle288, _circle289, _circle290, _circle291, _circle292, _circle293, _circle294, _circle295, _circle296, _circle297, _circle298, _circle299, _circle300, _circle301, _circle302, _circle303, _circle304, _circle305, _circle306, _circle307, _circle308, _circle309, _circle310, _circle311, _circle312;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCalifornia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__icon_california",
    width: 148.094,
    height: 172.202,
    viewBox: "0 0 148.094 172.202",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:#f0a022}\n        "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_48",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 48",
    transform: "translate(6.027)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_49",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 49",
    transform: "translate(12.054)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_50",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 50",
    transform: "translate(17.909)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_51",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 51",
    transform: "translate(23.936)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_52",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 52",
    transform: "translate(29.963)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_53",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 53",
    transform: "translate(35.99)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_54",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 54",
    transform: "translate(42.017)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_55",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 55",
    transform: "translate(48.044)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_56",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 56",
    transform: "translate(53.899)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_57",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 57",
    transform: "translate(59.926)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_58",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 58",
    transform: "translate(6.027 6.027)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_59",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 59",
    transform: "translate(12.054 6.027)"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_60",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 60",
    transform: "translate(17.909 6.027)"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_61",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 61",
    transform: "translate(23.936 6.027)"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_62",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 62",
    transform: "translate(29.963 6.027)"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_63",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 63",
    transform: "translate(35.99 6.027)"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_64",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 64",
    transform: "translate(42.017 6.027)"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_65",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 65",
    transform: "translate(48.044 6.027)"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_66",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 66",
    transform: "translate(53.899 6.027)"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_67",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 67",
    transform: "translate(59.926 6.027)"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_68",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 68",
    transform: "translate(6.027 12.054)"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_69",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 69",
    transform: "translate(12.054 12.054)"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_70",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 70",
    transform: "translate(17.909 12.054)"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_71",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 71",
    transform: "translate(23.936 12.054)"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_72",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 72",
    transform: "translate(29.963 12.054)"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_73",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 73",
    transform: "translate(35.99 12.054)"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_74",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 74",
    transform: "translate(42.017 12.054)"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_75",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 75",
    transform: "translate(48.044 12.054)"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_76",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 76",
    transform: "translate(53.899 12.054)"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_77",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 77",
    transform: "translate(59.926 12.054)"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_78",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 78",
    transform: "translate(6.027 18.081)"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_79",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 79",
    transform: "translate(12.054 18.081)"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_80",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 80",
    transform: "translate(17.909 18.081)"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_81",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 81",
    transform: "translate(23.936 18.081)"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_82",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 82",
    transform: "translate(29.963 18.081)"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_83",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 83",
    transform: "translate(35.99 18.081)"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_84",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 84",
    transform: "translate(42.017 18.081)"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_85",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 85",
    transform: "translate(48.044 18.081)"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_86",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 86",
    transform: "translate(53.899 18.081)"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_87",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 87",
    transform: "translate(59.926 18.081)"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_88",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 88",
    transform: "translate(0 24.109)"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_89",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 89",
    transform: "translate(6.027 24.109)"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_90",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 90",
    transform: "translate(12.054 24.109)"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_91",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 91",
    transform: "translate(17.909 24.109)"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_92",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 92",
    transform: "translate(23.936 24.109)"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_93",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 93",
    transform: "translate(29.963 24.109)"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_94",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 94",
    transform: "translate(35.99 24.109)"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_95",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 95",
    transform: "translate(42.017 24.109)"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_96",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 96",
    transform: "translate(48.044 24.109)"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_97",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 97",
    transform: "translate(53.899 24.109)"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_98",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 98",
    transform: "translate(59.926 24.109)"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_99",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 99",
    transform: "translate(0 29.963)"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_100",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 100",
    transform: "translate(6.027 29.963)"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_101",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 101",
    transform: "translate(12.054 29.963)"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_102",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 102",
    transform: "translate(17.909 29.963)"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_103",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 103",
    transform: "translate(23.936 29.963)"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_104",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 104",
    transform: "translate(29.963 29.963)"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_105",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 105",
    transform: "translate(35.99 29.963)"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_106",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 106",
    transform: "translate(42.017 29.963)"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_107",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 107",
    transform: "translate(48.044 29.963)"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_108",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 108",
    transform: "translate(53.899 29.963)"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_109",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 109",
    transform: "translate(59.926 29.963)"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_110",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 110",
    transform: "translate(6.027 35.99)"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_111",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 111",
    transform: "translate(12.054 35.99)"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_112",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 112",
    transform: "translate(17.909 35.99)"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_113",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 113",
    transform: "translate(23.936 35.99)"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_114",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 114",
    transform: "translate(29.963 35.99)"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_115",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 115",
    transform: "translate(35.99 35.99)"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_116",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 116",
    transform: "translate(42.017 35.99)"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_117",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 117",
    transform: "translate(48.044 35.99)"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_118",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 118",
    transform: "translate(53.899 35.99)"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_119",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 119",
    transform: "translate(59.926 35.99)"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_120",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 120",
    transform: "translate(12.054 42.018)"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_121",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 121",
    transform: "translate(17.909 42.018)"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_122",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 122",
    transform: "translate(23.936 42.018)"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_123",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 123",
    transform: "translate(29.963 42.018)"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_124",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 124",
    transform: "translate(35.99 42.018)"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_125",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 125",
    transform: "translate(42.017 42.018)"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_126",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 126",
    transform: "translate(48.044 42.018)"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_127",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 127",
    transform: "translate(53.899 42.018)"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_128",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 128",
    transform: "translate(59.926 42.018)"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_129",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 129",
    transform: "translate(12.054 48.044)"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_130",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 130",
    transform: "translate(17.909 48.044)"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_131",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 131",
    transform: "translate(23.936 48.044)"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_132",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 132",
    transform: "translate(29.963 48.044)"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_133",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 133",
    transform: "translate(35.99 48.044)"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_134",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 134",
    transform: "translate(42.017 48.044)"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_135",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 135",
    transform: "translate(48.044 48.044)"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_136",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 136",
    transform: "translate(53.899 48.044)"
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_137",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 137",
    transform: "translate(59.926 48.044)"
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_138",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 138",
    transform: "translate(12.054 54.071)"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_139",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 139",
    transform: "translate(17.909 54.071)"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_140",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 140",
    transform: "translate(23.936 54.071)"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_141",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 141",
    transform: "translate(29.963 54.071)"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_142",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 142",
    transform: "translate(35.99 54.071)"
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_143",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 143",
    transform: "translate(42.017 54.071)"
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_144",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 144",
    transform: "translate(48.044 54.071)"
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_145",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 145",
    transform: "translate(53.899 54.071)"
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_146",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 146",
    transform: "translate(59.926 54.071)"
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_147",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 147",
    transform: "translate(12.054 60.099)"
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_148",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 148",
    transform: "translate(17.909 60.099)"
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_149",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 149",
    transform: "translate(23.936 60.099)"
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_150",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 150",
    transform: "translate(29.963 60.099)"
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_151",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 151",
    transform: "translate(35.99 60.099)"
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_152",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 152",
    transform: "translate(42.017 60.099)"
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_153",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 153",
    transform: "translate(48.044 60.099)"
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_154",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 154",
    transform: "translate(53.899 60.099)"
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_155",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 155",
    transform: "translate(59.926 60.099)"
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_156",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 156",
    transform: "translate(65.953 60.099)"
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_157",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 157",
    transform: "translate(17.909 65.953)"
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_158",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 158",
    transform: "translate(23.936 65.953)"
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_159",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 159",
    transform: "translate(29.963 65.953)"
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_160",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 160",
    transform: "translate(35.99 65.953)"
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_161",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 161",
    transform: "translate(42.017 65.953)"
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_162",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 162",
    transform: "translate(48.044 65.953)"
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_163",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 163",
    transform: "translate(53.899 65.953)"
  })), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_164",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 164",
    transform: "translate(59.926 65.953)"
  })), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_165",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 165",
    transform: "translate(65.953 65.953)"
  })), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_166",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 166",
    transform: "translate(71.98 65.953)"
  })), _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_167",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 167",
    transform: "translate(23.936 71.98)"
  })), _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_168",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 168",
    transform: "translate(29.963 71.98)"
  })), _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_169",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 169",
    transform: "translate(35.99 71.98)"
  })), _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_170",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 170",
    transform: "translate(42.017 71.98)"
  })), _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_171",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 171",
    transform: "translate(48.044 71.98)"
  })), _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_172",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 172",
    transform: "translate(53.899 71.98)"
  })), _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_173",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 173",
    transform: "translate(59.926 71.98)"
  })), _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_174",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 174",
    transform: "translate(65.953 71.98)"
  })), _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_175",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 175",
    transform: "translate(71.98 71.98)"
  })), _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_176",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 176",
    transform: "translate(78.008 71.98)"
  })), _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_177",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 177",
    transform: "translate(29.963 78.008)"
  })), _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_178",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 178",
    transform: "translate(35.99 78.008)"
  })), _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_179",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 179",
    transform: "translate(42.017 78.008)"
  })), _circle133 || (_circle133 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_180",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 180",
    transform: "translate(48.044 78.008)"
  })), _circle134 || (_circle134 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_181",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 181",
    transform: "translate(53.899 78.008)"
  })), _circle135 || (_circle135 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_182",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 182",
    transform: "translate(59.926 78.008)"
  })), _circle136 || (_circle136 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_183",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 183",
    transform: "translate(65.953 78.008)"
  })), _circle137 || (_circle137 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_184",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 184",
    transform: "translate(71.98 78.008)"
  })), _circle138 || (_circle138 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_185",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 185",
    transform: "translate(78.008 78.008)"
  })), _circle139 || (_circle139 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_186",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 186",
    transform: "translate(84.034 78.008)"
  })), _circle140 || (_circle140 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_187",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 187",
    transform: "translate(29.963 84.035)"
  })), _circle141 || (_circle141 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_188",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 188",
    transform: "translate(35.99 84.035)"
  })), _circle142 || (_circle142 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_189",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 189",
    transform: "translate(42.017 84.035)"
  })), _circle143 || (_circle143 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_190",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 190",
    transform: "translate(48.044 84.035)"
  })), _circle144 || (_circle144 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_191",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 191",
    transform: "translate(53.899 84.035)"
  })), _circle145 || (_circle145 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_192",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 192",
    transform: "translate(59.926 84.035)"
  })), _circle146 || (_circle146 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_193",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 193",
    transform: "translate(65.953 84.035)"
  })), _circle147 || (_circle147 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_194",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 194",
    transform: "translate(71.98 84.035)"
  })), _circle148 || (_circle148 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_195",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 195",
    transform: "translate(78.008 84.035)"
  })), _circle149 || (_circle149 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_196",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 196",
    transform: "translate(84.034 84.035)"
  })), _circle150 || (_circle150 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_197",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 197",
    transform: "translate(90.062 84.035)"
  })), _circle151 || (_circle151 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_198",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 198",
    transform: "translate(29.963 90.062)"
  })), _circle152 || (_circle152 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_199",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 199",
    transform: "translate(35.99 90.062)"
  })), _circle153 || (_circle153 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_200",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 200",
    transform: "translate(42.017 90.062)"
  })), _circle154 || (_circle154 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_201",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 201",
    transform: "translate(48.044 90.062)"
  })), _circle155 || (_circle155 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_202",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 202",
    transform: "translate(53.899 90.062)"
  })), _circle156 || (_circle156 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_203",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 203",
    transform: "translate(59.926 90.062)"
  })), _circle157 || (_circle157 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_204",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 204",
    transform: "translate(65.953 90.062)"
  })), _circle158 || (_circle158 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_205",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 205",
    transform: "translate(71.98 90.062)"
  })), _circle159 || (_circle159 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_206",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 206",
    transform: "translate(78.008 90.062)"
  })), _circle160 || (_circle160 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_207",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 207",
    transform: "translate(84.034 90.062)"
  })), _circle161 || (_circle161 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_208",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 208",
    transform: "translate(90.062 90.062)"
  })), _circle162 || (_circle162 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_209",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 209",
    transform: "translate(95.916 90.062)"
  })), _circle163 || (_circle163 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_210",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 210",
    transform: "translate(35.99 96.089)"
  })), _circle164 || (_circle164 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_211",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 211",
    transform: "translate(42.017 96.089)"
  })), _circle165 || (_circle165 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_212",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 212",
    transform: "translate(48.044 96.089)"
  })), _circle166 || (_circle166 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_213",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 213",
    transform: "translate(53.899 96.089)"
  })), _circle167 || (_circle167 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_214",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 214",
    transform: "translate(59.926 96.089)"
  })), _circle168 || (_circle168 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_215",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 215",
    transform: "translate(65.953 96.089)"
  })), _circle169 || (_circle169 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_216",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 216",
    transform: "translate(71.98 96.089)"
  })), _circle170 || (_circle170 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_217",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 217",
    transform: "translate(78.008 96.089)"
  })), _circle171 || (_circle171 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_218",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 218",
    transform: "translate(84.034 96.089)"
  })), _circle172 || (_circle172 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_219",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 219",
    transform: "translate(90.062 96.089)"
  })), _circle173 || (_circle173 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_220",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 220",
    transform: "translate(95.916 96.089)"
  })), _circle174 || (_circle174 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_221",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 221",
    transform: "translate(101.944 96.089)"
  })), _circle175 || (_circle175 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_222",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 222",
    transform: "translate(35.99 102.116)"
  })), _circle176 || (_circle176 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_223",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 223",
    transform: "translate(42.017 102.116)"
  })), _circle177 || (_circle177 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_224",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 224",
    transform: "translate(48.044 102.116)"
  })), _circle178 || (_circle178 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_225",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 225",
    transform: "translate(53.899 102.116)"
  })), _circle179 || (_circle179 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_226",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 226",
    transform: "translate(59.926 102.116)"
  })), _circle180 || (_circle180 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_227",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 227",
    transform: "translate(65.953 102.116)"
  })), _circle181 || (_circle181 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_228",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 228",
    transform: "translate(71.98 102.116)"
  })), _circle182 || (_circle182 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_229",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 229",
    transform: "translate(78.008 102.116)"
  })), _circle183 || (_circle183 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_230",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 230",
    transform: "translate(84.034 102.116)"
  })), _circle184 || (_circle184 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_231",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 231",
    transform: "translate(90.062 102.116)"
  })), _circle185 || (_circle185 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_232",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 232",
    transform: "translate(95.916 102.116)"
  })), _circle186 || (_circle186 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_233",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 233",
    transform: "translate(101.944 102.116)"
  })), _circle187 || (_circle187 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_234",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 234",
    transform: "translate(107.97 102.116)"
  })), _circle188 || (_circle188 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_235",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 235",
    transform: "translate(42.017 107.971)"
  })), _circle189 || (_circle189 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_236",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 236",
    transform: "translate(48.044 107.971)"
  })), _circle190 || (_circle190 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_237",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 237",
    transform: "translate(53.899 107.971)"
  })), _circle191 || (_circle191 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_238",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 238",
    transform: "translate(59.926 107.971)"
  })), _circle192 || (_circle192 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_239",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 239",
    transform: "translate(65.953 107.971)"
  })), _circle193 || (_circle193 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_240",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 240",
    transform: "translate(71.98 107.971)"
  })), _circle194 || (_circle194 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_241",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 241",
    transform: "translate(78.008 107.971)"
  })), _circle195 || (_circle195 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_242",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 242",
    transform: "translate(84.034 107.971)"
  })), _circle196 || (_circle196 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_243",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 243",
    transform: "translate(90.062 107.971)"
  })), _circle197 || (_circle197 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_244",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 244",
    transform: "translate(95.916 107.971)"
  })), _circle198 || (_circle198 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_245",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 245",
    transform: "translate(101.944 107.971)"
  })), _circle199 || (_circle199 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_246",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 246",
    transform: "translate(107.97 107.971)"
  })), _circle200 || (_circle200 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_247",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 247",
    transform: "translate(113.997 107.971)"
  })), _circle201 || (_circle201 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_248",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 248",
    transform: "translate(42.017 113.998)"
  })), _circle202 || (_circle202 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_249",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 249",
    transform: "translate(48.044 113.998)"
  })), _circle203 || (_circle203 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_250",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 250",
    transform: "translate(53.899 113.998)"
  })), _circle204 || (_circle204 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_251",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 251",
    transform: "translate(59.926 113.998)"
  })), _circle205 || (_circle205 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_252",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 252",
    transform: "translate(65.953 113.998)"
  })), _circle206 || (_circle206 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_253",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 253",
    transform: "translate(71.98 113.998)"
  })), _circle207 || (_circle207 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_254",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 254",
    transform: "translate(78.008 113.998)"
  })), _circle208 || (_circle208 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_255",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 255",
    transform: "translate(84.034 113.998)"
  })), _circle209 || (_circle209 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_256",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 256",
    transform: "translate(90.062 113.998)"
  })), _circle210 || (_circle210 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_257",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 257",
    transform: "translate(95.916 113.998)"
  })), _circle211 || (_circle211 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_258",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 258",
    transform: "translate(101.944 113.998)"
  })), _circle212 || (_circle212 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_259",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 259",
    transform: "translate(107.97 113.998)"
  })), _circle213 || (_circle213 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_260",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 260",
    transform: "translate(113.997 113.998)"
  })), _circle214 || (_circle214 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_261",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 261",
    transform: "translate(120.025 113.998)"
  })), _circle215 || (_circle215 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_262",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 262",
    transform: "translate(48.044 120.025)"
  })), _circle216 || (_circle216 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_263",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 263",
    transform: "translate(53.899 120.025)"
  })), _circle217 || (_circle217 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_264",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 264",
    transform: "translate(59.926 120.025)"
  })), _circle218 || (_circle218 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_265",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 265",
    transform: "translate(65.953 120.025)"
  })), _circle219 || (_circle219 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_266",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 266",
    transform: "translate(71.98 120.025)"
  })), _circle220 || (_circle220 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_267",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 267",
    transform: "translate(78.008 120.025)"
  })), _circle221 || (_circle221 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_268",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 268",
    transform: "translate(84.034 120.025)"
  })), _circle222 || (_circle222 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_269",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 269",
    transform: "translate(90.062 120.025)"
  })), _circle223 || (_circle223 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_270",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 270",
    transform: "translate(95.916 120.025)"
  })), _circle224 || (_circle224 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_271",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 271",
    transform: "translate(101.944 120.025)"
  })), _circle225 || (_circle225 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_272",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 272",
    transform: "translate(107.97 120.025)"
  })), _circle226 || (_circle226 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_273",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 273",
    transform: "translate(113.997 120.025)"
  })), _circle227 || (_circle227 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_274",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 274",
    transform: "translate(120.025 120.025)"
  })), _circle228 || (_circle228 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_275",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 275",
    transform: "translate(126.051 120.025)"
  })), _circle229 || (_circle229 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_276",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 276",
    transform: "translate(53.899 126.052)"
  })), _circle230 || (_circle230 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_277",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 277",
    transform: "translate(59.926 126.052)"
  })), _circle231 || (_circle231 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_278",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 278",
    transform: "translate(65.953 126.052)"
  })), _circle232 || (_circle232 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_279",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 279",
    transform: "translate(71.98 126.052)"
  })), _circle233 || (_circle233 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_280",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 280",
    transform: "translate(78.008 126.052)"
  })), _circle234 || (_circle234 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_281",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 281",
    transform: "translate(84.034 126.052)"
  })), _circle235 || (_circle235 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_282",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 282",
    transform: "translate(90.062 126.052)"
  })), _circle236 || (_circle236 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_283",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 283",
    transform: "translate(95.916 126.052)"
  })), _circle237 || (_circle237 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_284",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 284",
    transform: "translate(101.944 126.052)"
  })), _circle238 || (_circle238 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_285",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 285",
    transform: "translate(107.97 126.052)"
  })), _circle239 || (_circle239 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_286",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 286",
    transform: "translate(113.997 126.052)"
  })), _circle240 || (_circle240 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_287",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 287",
    transform: "translate(120.025 126.052)"
  })), _circle241 || (_circle241 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_288",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 288",
    transform: "translate(126.051 126.052)"
  })), _circle242 || (_circle242 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_289",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 289",
    transform: "translate(131.907 126.052)"
  })), _circle243 || (_circle243 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_290",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 290",
    transform: "translate(53.899 132.079)"
  })), _circle244 || (_circle244 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_291",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 291",
    transform: "translate(59.926 132.079)"
  })), _circle245 || (_circle245 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_292",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 292",
    transform: "translate(65.953 132.079)"
  })), _circle246 || (_circle246 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_293",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 293",
    transform: "translate(71.98 132.079)"
  })), _circle247 || (_circle247 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_294",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 294",
    transform: "translate(78.008 132.079)"
  })), _circle248 || (_circle248 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_295",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 295",
    transform: "translate(84.034 132.079)"
  })), _circle249 || (_circle249 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_296",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 296",
    transform: "translate(90.062 132.079)"
  })), _circle250 || (_circle250 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_297",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 297",
    transform: "translate(95.916 132.079)"
  })), _circle251 || (_circle251 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_298",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 298",
    transform: "translate(101.944 132.079)"
  })), _circle252 || (_circle252 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_299",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 299",
    transform: "translate(107.97 132.079)"
  })), _circle253 || (_circle253 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_300",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 300",
    transform: "translate(113.997 132.079)"
  })), _circle254 || (_circle254 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_301",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 301",
    transform: "translate(120.025 132.079)"
  })), _circle255 || (_circle255 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_302",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 302",
    transform: "translate(126.051 132.079)"
  })), _circle256 || (_circle256 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_303",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 303",
    transform: "translate(131.907 132.079)"
  })), _circle257 || (_circle257 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_304",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 304",
    transform: "translate(137.933 132.079)"
  })), _circle258 || (_circle258 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_305",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 305",
    transform: "translate(71.98 138.106)"
  })), _circle259 || (_circle259 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_306",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 306",
    transform: "translate(78.008 138.106)"
  })), _circle260 || (_circle260 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_307",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 307",
    transform: "translate(84.034 138.106)"
  })), _circle261 || (_circle261 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_308",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 308",
    transform: "translate(90.062 138.106)"
  })), _circle262 || (_circle262 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_309",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 309",
    transform: "translate(95.916 138.106)"
  })), _circle263 || (_circle263 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_310",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 310",
    transform: "translate(101.944 138.106)"
  })), _circle264 || (_circle264 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_311",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 311",
    transform: "translate(107.97 138.106)"
  })), _circle265 || (_circle265 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_312",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 312",
    transform: "translate(113.997 138.106)"
  })), _circle266 || (_circle266 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_313",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 313",
    transform: "translate(120.025 138.106)"
  })), _circle267 || (_circle267 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_314",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 314",
    transform: "translate(126.051 138.106)"
  })), _circle268 || (_circle268 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_315",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 315",
    transform: "translate(131.907 138.106)"
  })), _circle269 || (_circle269 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_316",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 316",
    transform: "translate(137.933 138.106)"
  })), _circle270 || (_circle270 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_317",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 317",
    transform: "translate(143.961 138.106)"
  })), _circle271 || (_circle271 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_318",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 318",
    transform: "translate(59.926 143.961)"
  })), _circle272 || (_circle272 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_319",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 319",
    transform: "translate(65.953 143.961)"
  })), _circle273 || (_circle273 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_320",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 320",
    transform: "translate(84.034 143.961)"
  })), _circle274 || (_circle274 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_321",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 321",
    transform: "translate(90.062 143.961)"
  })), _circle275 || (_circle275 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_322",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 322",
    transform: "translate(95.916 143.961)"
  })), _circle276 || (_circle276 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_323",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 323",
    transform: "translate(101.944 143.961)"
  })), _circle277 || (_circle277 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_324",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 324",
    transform: "translate(107.97 143.961)"
  })), _circle278 || (_circle278 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_325",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 325",
    transform: "translate(113.997 143.961)"
  })), _circle279 || (_circle279 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_326",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 326",
    transform: "translate(120.025 143.961)"
  })), _circle280 || (_circle280 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_327",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 327",
    transform: "translate(126.051 143.961)"
  })), _circle281 || (_circle281 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_328",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 328",
    transform: "translate(131.907 143.961)"
  })), _circle282 || (_circle282 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_329",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 329",
    transform: "translate(137.933 143.961)"
  })), _circle283 || (_circle283 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_330",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 330",
    transform: "translate(95.916 149.988)"
  })), _circle284 || (_circle284 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_331",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 331",
    transform: "translate(101.944 149.988)"
  })), _circle285 || (_circle285 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_332",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 332",
    transform: "translate(107.97 149.988)"
  })), _circle286 || (_circle286 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_333",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 333",
    transform: "translate(113.997 149.988)"
  })), _circle287 || (_circle287 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_334",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 334",
    transform: "translate(120.025 149.988)"
  })), _circle288 || (_circle288 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_335",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 335",
    transform: "translate(126.051 149.988)"
  })), _circle289 || (_circle289 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_336",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 336",
    transform: "translate(131.907 149.988)"
  })), _circle290 || (_circle290 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_337",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 337",
    transform: "translate(137.933 149.988)"
  })), _circle291 || (_circle291 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_338",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 338",
    transform: "translate(71.98 156.015)"
  })), _circle292 || (_circle292 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_339",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 339",
    transform: "translate(84.034 156.015)"
  })), _circle293 || (_circle293 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_340",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 340",
    transform: "translate(101.944 156.015)"
  })), _circle294 || (_circle294 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_341",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 341",
    transform: "translate(107.97 156.015)"
  })), _circle295 || (_circle295 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_342",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 342",
    transform: "translate(113.997 156.015)"
  })), _circle296 || (_circle296 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_343",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 343",
    transform: "translate(120.025 156.015)"
  })), _circle297 || (_circle297 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_344",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 344",
    transform: "translate(126.051 156.015)"
  })), _circle298 || (_circle298 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_345",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 345",
    transform: "translate(131.907 156.015)"
  })), _circle299 || (_circle299 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_346",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 346",
    transform: "translate(84.034 162.042)"
  })), _circle300 || (_circle300 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_347",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 347",
    transform: "translate(101.944 162.042)"
  })), _circle301 || (_circle301 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_348",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 348",
    transform: "translate(107.97 162.042)"
  })), _circle302 || (_circle302 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_349",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 349",
    transform: "translate(113.997 162.042)"
  })), _circle303 || (_circle303 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_350",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 350",
    transform: "translate(120.025 162.042)"
  })), _circle304 || (_circle304 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_351",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 351",
    transform: "translate(126.051 162.042)"
  })), _circle305 || (_circle305 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_352",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 352",
    transform: "translate(131.907 162.042)"
  })), _circle306 || (_circle306 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_353",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 353",
    transform: "translate(126.051 167.897)"
  })), _circle307 || (_circle307 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_354",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 354",
    transform: "translate(131.907 167.897)"
  })), _circle308 || (_circle308 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_355",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 355",
    transform: "translate(137.933 162.042)"
  })), _circle309 || (_circle309 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_356",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 356",
    transform: "translate(101.944 168.069)"
  })), _circle310 || (_circle310 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_357",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 357",
    transform: "translate(107.97 168.069)"
  })), _circle311 || (_circle311 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_358",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 358",
    transform: "translate(113.997 168.069)"
  })), _circle312 || (_circle312 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_359",
    cx: 2.066,
    cy: 2.066,
    r: 2.066,
    className: "prefix__cls-1",
    "data-name": "Ellipse 359",
    transform: "translate(120.025 168.069)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalifornia);
export default __webpack_public_path__ + "static/media/icon-california.0803647052286ae8e030b8facb4a5e14.svg";
export { ForwardRef as ReactComponent };